//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '@nuxtjs/composition-api';
import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import { productGetters } from '@vsf-enterprise/sapcc';
export default defineComponent({
  name: 'ProductHeader',
  components: { SfHeading },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  setup() {
    return { productGetters };
  }
});
